{
  "bank": "银行卡",
  "alipay": "支付宝",
  "wechat": "微信",
  "ermb": "数字人民币",
  "qq": "QQ"
}